module.exports = __webpack_public_path__ + "static/media/TeachOne_wht.03dbaa84.png";